// extracted by mini-css-extract-plugin
export default {"FlipperVaultCardInfoItemTitle":"info-tags_FlipperVaultCardInfoItemTitle__5UJCg","FlipperVaultCardInfoItemValue":"info-tags_FlipperVaultCardInfoItemValue__12OoG"};